/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyOrderImportSummaryDtoBase
 * auto generated base class for the model ShopifyOrderImportSummaryDtoModel.
 */
export const ShopifyOrderImportSummaryDtoModelBase = ModelBase
  .named('ShopifyOrderImportSummaryDto')
  .props({
    __typename: types.optional(types.literal("ShopifyOrderImportSummaryDto"), "ShopifyOrderImportSummaryDto"),
    requested: types.union(types.undefined, types.integer),
    created: types.union(types.undefined, types.integer),
    skipped: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyOrderImportSummaryDtoModelSelector extends QueryBuilder {
  get requested() { return this.__attr(`requested`) }
  get created() { return this.__attr(`created`) }
  get skipped() { return this.__attr(`skipped`) }
}
export function selectFromShopifyOrderImportSummaryDto() {
  return new ShopifyOrderImportSummaryDtoModelSelector()
}

export const shopifyOrderImportSummaryDtoModelPrimitives = selectFromShopifyOrderImportSummaryDto().requested.created.skipped
